import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"add\"><circle cx=\"11.5\" cy=\"11.5\" r=\"9\" stroke-linecap=\"round\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" /><path stroke-linecap=\"round\" fill=\"none\" stroke=\"currentColor\" d=\"M11.5 6v11M6 11.5h11\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol